module.exports = __webpack_public_path__ + "assets/img/denizbank@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/denizbank@2x.png
// module id = 130
// module chunks = 0